module.exports = __webpack_public_path__ + "img/calendar.bdcbcd28.png";